import {
  EKwikUIButtonAppearance,
  EKwikUIButtonSize,
  EKwikUIButtonType
} from "./button.definitions";

export const DEFAULT_VALUES = {
  appearance: EKwikUIButtonAppearance.PRIMARY,
  class: "",
  disabled: false,
  icon: "",
  iconRight: "",
  id: "button",
  label: "",
  shape: null,
  showLoader: false,
  size: EKwikUIButtonSize.M,
  styles: "",
  type: EKwikUIButtonType.BUTTON,
  pseudoHover: null
};

export const VALIDATE_KEY_VALUES = {
  appearance: true,
  class: true,
  disabled: true,
  icon: true,
  iconRight: true,
  id: true,
  label: true,
  shape: true,
  showLoader: true,
  size: true,
  styles: true,
  type: true
};
